import { render, staticRenderFns } from "./registered-sao-paulo.vue?vue&type=template&id=1fd329b2"
import script from "./registered-sao-paulo.vue?vue&type=script&lang=js"
export * from "./registered-sao-paulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports